import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import Cookies from 'js-cookie';
import { promiseTimeout } from '@vueuse/core';
import { CookieKey } from '~/core/enums';
import { useAppLink } from '~/core/composables';
import { ymGoal } from '~/core/utils/yandexReachGoal';
import { SMART_BANNER_DISABLED_PATHS } from '~/core/constants/smartBanner';
import useMainStore from '~/stores/useMainStore';
export default defineComponent({
  name: 'AppSmartBanner',
  props: {
    app: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup() {
    var mainStore = useMainStore();
    var _useNuxtApp = useNuxtApp(),
      $device = _useNuxtApp.$device;
    var _useAppLink = useAppLink(),
      storeLink = _useAppLink.storeLink,
      deepLink = _useAppLink.deepLink;
    var $route = useRoute();
    var isAvailable = computed(function () {
      return !SMART_BANNER_DISABLED_PATHS.find(function (path) {
        return $route.path.includes(path);
      });
    });
    var isActive = computed(function () {
      return isAvailable.value && mainStore.isSmartAppBannerActive;
    });
    function handleOpenStore() {
      if ($device.isIos) {
        window.open(storeLink.value);
        return;
      }
      location.href = storeLink.value;
    }
    function handleOpen() {
      return _handleOpen.apply(this, arguments);
    }
    function _handleOpen() {
      _handleOpen = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ymGoal('clickApp');
              location.href = deepLink.value;
              _context.next = 4;
              return promiseTimeout(1000);
            case 4:
              location.href = storeLink.value;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handleOpen.apply(this, arguments);
    }
    function close() {
      Cookies.set(CookieKey.AppSmartBannerWasClosed, 'true', {
        expires: 1
      });
      mainStore.isSmartAppBannerActive = false;
    }
    return {
      storeLink: storeLink,
      isActive: isActive,
      handleOpen: handleOpen,
      handleOpenStore: handleOpenStore,
      close: close
    };
  }
});